import type { NavigateFunction } from 'react-router-dom'

import { navigateTo } from '~publish/helpers/navigation'

let routerNavigateFn: NavigateFunction | null = null

/**
 * Registers the live router `navigate` function. Rendered once by
 * `RouterNavigateBridge` inside the `BrowserRouter`; not for direct use.
 */
export function setRouterNavigate(navigate: NavigateFunction | null): void {
  routerNavigateFn = navigate
}

/**
 * Navigates Publish's router from code that runs outside the React tree
 * (legacy Flux and Redux flows, e.g. the composer's post-save toast).
 *
 * React Router only exposes navigation through hooks and components, so
 * non-React code has nothing to call. `RouterNavigateBridge` stores the
 * router's `navigate` here while the router is mounted. Prefer `useNavigate`
 * in React code; this is the escape hatch for everything else.
 *
 * Without a mounted router the navigation degrades to a full-page load.
 */
export function routerNavigate(path: string): void {
  if (routerNavigateFn) {
    void routerNavigateFn(path)
    return
  }

  navigateTo(path)
}
